import { axiosBase } from "utils";

/* ---------------- Dashboard & Meta ---------------- */
export function ticketDashboardService() {
  return axiosBase.create()({ method: "GET", url: "/ticket-meta/dashboard" });
}
export function ticketUsersService() {
  return axiosBase.create()({ method: "GET", url: "/ticket-meta/users" });
}

/* ---------------- Projects ---------------- */
export function ticketProjectListService(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return axiosBase.create()({
    method: "GET",
    url: "/ticket-project" + (qs ? "?" + qs : ""),
  });
}
export function ticketProjectByIdService(id) {
  return axiosBase.create()({ method: "GET", url: "/ticket-project/" + id });
}
export function ticketProjectBoardService(id) {
  return axiosBase.create()({ method: "GET", url: "/ticket-project/" + id + "/board" });
}
export function ticketProjectCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/ticket-project", data });
}
export function ticketProjectUpdateService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/ticket-project/" + id, data });
}
export function ticketProjectDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/ticket-project/" + id });
}

/* ---------------- Lists ---------------- */
export function ticketListByProjectService(projectId) {
  return axiosBase.create()({ method: "GET", url: "/ticket-list/project/" + projectId });
}
export function ticketListCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/ticket-list", data });
}
export function ticketListUpdateService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/ticket-list/" + id, data });
}
export function ticketListReorderService(items) {
  return axiosBase.create()({ method: "PATCH", url: "/ticket-list/reorder", data: { items } });
}
export function ticketListDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/ticket-list/" + id });
}

/* ---------------- Tickets ---------------- */
export function ticketListService(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return axiosBase.create()({
    method: "GET",
    url: "/ticket" + (qs ? "?" + qs : ""),
  });
}
export function ticketByIdService(id) {
  return axiosBase.create()({ method: "GET", url: "/ticket/" + id });
}
export function ticketCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/ticket", data });
}
export function ticketUpdateService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/ticket/" + id, data });
}
export function ticketMoveService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/ticket/" + id + "/move", data });
}
export function ticketDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/ticket/" + id });
}

/* ---------------- Comments ---------------- */
export function ticketCommentListService(ticketId) {
  return axiosBase.create()({ method: "GET", url: "/ticket-comment/ticket/" + ticketId });
}
export function ticketCommentCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/ticket-comment", data });
}
export function ticketCommentDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/ticket-comment/" + id });
}

/* ---------------- Attachments ---------------- */
export function ticketAttachmentListService(ticketId) {
  return axiosBase.create()({ method: "GET", url: "/ticket-attachment/ticket/" + ticketId });
}
export function ticketAttachmentDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/ticket-attachment/" + id });
}
